import httpService from '@/modules/common/services/httpService';

// Reads go through the business-scoped settings API. The client-facing platform API
// deliberately caps what it returns - a single service on a single_service_booking plan,
// max_free_services (5) otherwise - which hid services from the businesses that own them
// (VCITA2-15147). That cap is applied before paging, so paging could never reach past it.
// settings/services returns the business's full list in one response, so there are no
// pages to walk.
const servicesRoute = '/v2/settings/services';

const fetchServices = () => httpService.get(servicesRoute).then((res) => res.data);

const bulkCreateServices = (
  params,
) => httpService.post(`${servicesRoute}/bulk_create`, params).then((res) => res.data);

export default {
  fetchServices,
  bulkCreateServices,
};
